var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 39 39"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 37.587,
  height: 37.587,
  x: 0.587,
  y: 0.5,
  fill: "#9747FF",
  rx: 18.794
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#twitch_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#9747FF",
  d: "m27.562 19.973-3.043 3.068h-3.043l-2.662 2.685V23.04H15.39V11.535h12.17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M27.561 19.972 24.52 23.04h-3.043l-2.663 2.685V23.04H15.39V11.534h12.171zM14.63 10l-3.804 3.835v13.808h4.564v3.835l3.804-3.835h3.043l6.846-6.904V10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.758 18.822h1.521v-4.603h-1.521zm-4.184 0h1.522v-4.603h-1.522z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "twitch_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.826 10H29.16v21.389H10.826z"
})))));
export default SvgTwitch;